import { AxiosResponse } from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

import { SignIn as ContextSignIn } from '../../../Context';

class CentroDeCusto {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Retorna todos os centros de custos (obra) que o usuário possua permissão de acesso
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {string} NivelDeVisualizacao Informe o "Id" que identifica o nível de visualização. A lista dos níveis de visualizações cadastradas poderá ser obtido ao executar a requisição "/CentroDeCusto/NiveisDeVisualizacoes/{Token}"
     **/
    public async Get(Token: string, NivelDeVisualizacao: string): Promise<AxiosResponse<Array<Objeto.CentroDeCusto>>> {
        return await Context.get(`/CentroDeCusto/${Token}/${1}?NivelDeVisualizacao=${NivelDeVisualizacao}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Autoriza a pessoa, atrelada ao usuário, o acesso a um determinado centro de custo
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe a sigla que identifica o centro de custo. A lista dos centros de custos cadastrados poderá ser obtido ao executar a requisição "/CentroDeCusto/{Token}/{Empresa}"
     * @param {number} Pessoa Informe o código da pessoa (Id). Esta pessoa deverá estar cadastrada como um usuário do sistema!
     **/
    public async AutorizarPermissaoDeAcesso(Token: string, Empresa: number, CentroDeCusto: string, Pessoa: number): Promise<AxiosResponse<any>> {
        return await Context.post(`/CentroDeCusto/AutorizarPermissaoDeAcesso/${Token}/${Empresa}/${CentroDeCusto}/${Pessoa}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */
};

export default new CentroDeCusto();